<template>
<div>
  <p>{{$lang('家庭成員: ')}}</p>
  <ul class="list">
    <li v-for="(item,index) in list" :key="index"><span class="point"></span>{{changeName(item)}}</li>
  </ul>
</div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default () {
        return {
          gender: "M",
          birbornAtth: '',
          idNumber: '',
          lastName: "travis",
          firstName: "travis",
        }
      }
    }
  },
  methods: {
    changeName(item) {
      return (item.firstName || item.lastNameOther) + (item.lastName || item.firstNameOther)
    },
  }
}
</script>
